import { render, staticRenderFns } from "./ShowDialog.vue?vue&type=template&id=5cab2c06&"
import script from "./ShowDialog.vue?vue&type=script&lang=ts&"
export * from "./ShowDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports